import { z } from "zod";

export const NumericStringSchema = z.string().refine(
  (val) => {
    if (!val) return true;
    const num = parseInt(val, 10);
    return String(num) === val;
  },
  { message: "must be a numeric" },
);

/** NOTE: environment variables marked with NX_PUBLIC_ will have their values from process.env
 *  injected at build-time. All other variables are intended to come from runtime process.env.
 *
 *  If a variable exists in both build-time and runtime, the runtime value takes precedence.
 *
 *  As this is a shared env schema, keep in mind that the frontend doesn't really have a concept
 *  of runtime process.env, so non NX_PUBLIC_ variables aren't strictly usable in that sense.
 */
export const SharedEnvironmentSchema = z.object({
  NX_PUBLIC_DEPLOY_ALIAS: z.string().min(1),
  NX_PUBLIC_CORE_API_URL: z.string().url().optional().or(z.literal("")),
  NX_PUBLIC_ACCOUNT_API_URL: z.string().url().optional().or(z.literal("")),
  NX_PUBLIC_ADMIN_API_URL: z.string().url().optional().or(z.literal("")),
  NX_PUBLIC_REVIEW_ID: NumericStringSchema.optional(),
});
